import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(VSwitch, {
        staticClass: "pt-3 pb-2 font-weight-regular",
        attrs: {
          label: _vm.params.toggleLabel,
          "input-value": _vm.params.toggleValue,
          "true-value": _vm.params.trueValue,
          "false-value": _vm.params.falseValue,
          primary: "",
          "hide-details": "",
        },
        on: { change: _vm.toggle },
      }),
      _vm._v(" "),
      _c(VRow, { attrs: { align: "center", dense: "", "no-gutters": "" } }, [
        _c("div", { staticClass: "pb-2" }, [
          _vm._v(_vm._s(_vm.params.headerLine1)),
        ]),
        _vm._v(" "),
        _vm.params.displayCompetitorsSelection
          ? _c("div", [_c("competitors-selector")], 1)
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.params.headerLine2
        ? _c("div", { staticClass: "header-line2" }, [
            _vm._v(_vm._s(_vm.params.headerLine2)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }